export default __webpack_public_path__ + "static/study-banner-img-e6f2de6ec48ab29555b7398362075f20.jpg";